export enum MicrositesTabs {
  HOME = 'home',
  CATALOG = 'catalog',
  CATEGORY = 'category',
  ACTIVE_SITE = 'active-site'
}
